module.exports = __webpack_public_path__ + "img/axxios.27ff231b.png";